import Message from "../../message";
import {useMainStore} from "@/store";

export default class MembersHere extends Message
{
    handle()
    {
        Object.keys(this.message).forEach(k => {
            useMainStore().SET_GUILD_MEMBER_ONLINE(this.message[k].id);
        });
    }
}
